/** Play → Analyze → Create — shared copy for Home (WD-04) and FootyLab (F3 photos). */
export const homeMethodology = {
  id: 'how-it-works',
  title: 'How footyLab works',
  subtitle: 'Play, analyze, and create — soccer first, then the data from that game.',
  steps: [
    {
      id: 'play',
      title: 'Play',
      phrase: 'Get moving',
      description: 'Play soccer and collect movement data from your own game.',
      image: '/media/play-800.webp',
      alt: 'Students in numbered GPS vests play soccer on a grass field.',
      caption: 'Students wear GPS vests and play soccer.',
    },
    {
      id: 'analyze',
      title: 'Analyze',
      phrase: 'Get curious',
      description:
        'Use Python to turn that data into patterns, questions, and discoveries.',
      image: '/media/analyze-800.webp',
      alt: 'Students sit in a classroom looking at a movement graph on a wall screen.',
      caption: 'A class looks at movement data together.',
    },
    {
      id: 'create',
      title: 'Create',
      phrase: 'Make it yours',
      description: 'Build a dashboard or data story, then share what you learned.',
      image: '/media/create-800.webp',
      alt: 'A student stands beside a large screen showing a footyLab distance chart.',
      caption: 'A student presents a footyLab chart.',
    },
  ],
};
